import {ROLE_BEHEERDER, ROLE_DEVELOPER, ROLE_HELPDESK_MEDEWERKER, ROLE_SCHOOLBEHEERDER} from '~/constants/roles';

export default ({store, redirect}) => {
  if (store.state.auth.loggedIn && ![ROLE_SCHOOLBEHEERDER, ROLE_DEVELOPER, ROLE_HELPDESK_MEDEWERKER, ROLE_BEHEERDER].includes(store.state.auth.user.role_id)) {
    return redirect('/account');
  }
};
